<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="120px"
    >
      <div class="welcome-box">
        <SpWelcome
          :form="form"
          :mini-length="1"
        />
      </div>

      <div class="fotter-toolbar">
        <el-button
          type="primary"
          :loading="loading"
          @click="onSubmit"
        >
          立即创建
        </el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false,
      form: {
        channel_source: 1, //渠道来源：0新客，1社群，2活码
        text_msg: '',
        msg_type: 0, //消息类型：0图片，1链接，2小程序
        content: {
          image: {
            img_url: '',
            image_type: 'image/png'
          },
          link: {
            title: '链接',
            url: '',
            picurl: '',
            desc: ''
          },
          miniprogram: {
            title: '',
            img_url: '',
            page: '',
            image_type: 'image/png'
          }
        },
        attachments: []
      },
      welcomeMsgId: 0
    }
  },
  mounted () {
    let params = this.$route.params
    if (+params.id) {
      this.welcomeMsgId = params.id
      this.getInfo(params.id)
    }
  },
  methods: {
    // 获取详情
    async getInfo (id) {
      const data = await this.$api.customerConversion.getWelcomeInfo(id)

      if (data) {
        // 兼容老数据
        if (data.content.image) {
          data.content.image.pic_url = data.content.image.img_url
          data.attachments = [
            {
              msgtype: 'image',
              image: data.content.image
            }
          ]
        } else if (data.content.link) {
          data.attachments = [
            {
              msgtype: 'link',
              link: data.content.link
            }
          ]
        } else if (data.content.miniprogram) {
          data.attachments = [
            {
              msgtype: 'miniprogram',
              miniprogram: data.content.miniprogram
            }
          ]
        } else {
          data.attachments = []
        }

        console.log(data, '处理过的接口返回数据')
        this.form = data
      }
    },

    async onSubmit () {
      this.loading = true
      const { text_msg, msg_type, channel_source } = this.form
      let params = {
        text_msg,
        msg_type,
        content: {},
        channel_source
      }

      if (this.form.attachments && this.form.attachments.length > 0) {
        // 兼容老数据
        let attachment = this.form.attachments[0]
        if (attachment.msgtype === 'image') {
          attachment.image.img_url = attachment.image.pic_url
        }
        params.content[attachment.msgtype] = attachment[attachment.msgtype]
      }

      const data = await this.$api.customerConversion
        .saveWelcome(this.welcomeMsgId, params)
        .catch(() => {
          this.loading = false
        })

      if (data) {
        this.loading = false
        this.$message({
          message: '保存成功',
          type: 'success'
        })
        this.$router.push({ path: '/membership/membershipWelcome', replace: true })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-divider--horizontal {
  margin-top: 10px;
}
.guide-box {
  display: flex;
  align-items: center;
  width: auto;
  .guide-number {
    display: flex;
    align-items: center;
    .pic {
      display: inline-block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
      border-radius: 50%;
    }
    margin-right: 10px;
  }
  .guide-deparment {
    display: flex;
    align-items: center;
    .pic-folder {
      display: inline-block;
      width: 18px;
      height: 18px;
      background: url('../../assets/img/folder.png') no-repeat;
      background-size: contain;
      margin-right: 4px;
    }
  }
}
.welcome-box {
  background-color: #fff;
  margin-bottom: 20px;
}
</style>
